import React from "react"
import { useTranslation } from "react-i18next"
import PriceFilter from "./PriceFilter"
import Duration from "./Duration"
import Countries from "./Countries"
import Airports from "./Airports"
import Airlines from "./Airlines"
import Button from "../ui/Button"
import { RotateCcw } from "lucide-react"
import MobileFiltersModal from "./MobileFiltersModal"

const FiltersContainer = ({
  filters,
  priceRange,
  foundCurrency,
  countries,
  airports,
  airlines,
  initialSelectedCountryIds,
  initialSelectedAirportIds,

  // Handlers
  onChange,
  handleCountryChange,
  handleAirportChange,
  handleResetFilters,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <div className="bg-white hidden xl:flex w-[15%] xl:w-[25%] rounded-md shadow-md  flex-col h-full pt-4">
        <div className="overflow-hidden px-2 flex-1">
          <PriceFilter
            priceRange={priceRange}
            min={filters.price.min}
            max={filters.price.max}
            currency={foundCurrency}
            onChange={onChange}
          />

          <Duration
            duration={filters.flightDuration}
            title={t("admin.flight_duration_v2")}
            onChange={onChange}
            t={t}
          />
          {airlines.length > 0 && (
            <Airlines
              selectedCodes={filters.airlinesCodes}
              airlines={airlines}
              onChange={onChange}
            />
          )}

          <Countries
            countries={countries}
            onChange={handleCountryChange}
            initialSelectedCountryIds={initialSelectedCountryIds}
          />

          <Airports
            airports={airports}
            initialSelectedCountryIds={initialSelectedAirportIds}
            onChange={(id) => {
              handleAirportChange(id)
              onChange({ key: "terminalsIds", value: id })
            }}
          />
        </div>

        <div className="flex items-center px-4 w-full justify-center gap-1 pb-[18px] pt-1">
          <Button
            onClick={() =>
              handleResetFilters({
                resetCountries: () => handleCountryChange("reset"),
                resetAirports: () => handleAirportChange("reset"),
              })
            }
            className="w-full xl:w-auto"
            color=""
            size="md"
          >
            <div className="flex items-center justify-center gap-1 text-dark-red">
              <RotateCcw size={18} /> <span>{t("admin.reset")}</span>
            </div>
          </Button>
        </div>
      </div>

      <MobileFiltersModal
        filters={filters}
        priceRange={priceRange}
        foundCurrency={foundCurrency}
        countries={countries}
        airports={airports}
        airlines={airlines}
        initialSelectedCountryIds={initialSelectedCountryIds}
        initialSelectedAirportIds={initialSelectedAirportIds}
        onChange={onChange}
        handleCountryChange={handleCountryChange}
        handleAirportChange={handleAirportChange}
        handleResetFilters={handleResetFilters}
      />
    </>
  )
}

export default FiltersContainer
